import React, { Fragment, useCallback, useEffect, useState } from "react";
import moment from "moment";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import { RemoveRedEyeOutlined } from "@mui/icons-material";
import ModalRecordTime from "./components/ModalRecordTime";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import DropdownButton from "../../../components/button/DropdownButton";
import UploadAvatar from "../../../components/upload/UploadAvatar";
import InputTextField from "../../../components/input/inputTextField";
import { useParams } from "react-router-dom";
import { workScheduleApi } from "../../../api/work-schedule/work-schedule.api";
import { ButtonBack } from "../../../components/button/ButtonCustoms";
import { ReportApi } from "../../../api/report/Report.api";
import { saveAs } from "file-saver";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import StateComponents from "../../../components/state-component/StateComponents";

type Props = {};

const ManageTimeRecordSystemDetail: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const employeeId = id ? parseInt(id) : 0;
  const location = useLocation();
  const pathname = location.pathname;

  const [dataTimeRecord, setDataTimeRecord] = useState([]);
  const [inputValueSearch, setInputValue] = useState({
    fullname: "",
    employee_no: "",
    position: "",
    department: "",
    profile: "",
    percent: 0,
  });
  const [dataTimeRecordDetail, setDataTimeRecordDetail] = useState<any>({
    id_work_schedule: 0,
    date: "",
    check_in: "",
    check_out: "",
    number_of_hours: "",
    latitude_in: "",
    longitude_in: "",
    latitude_out: "",
    longitude_out: "",
    detail_in: "",
    detail_out: "",
    file_path_in: "",
    file_path_out: "",
  });

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(
    dataTimeRecord && dataTimeRecord.length
  );
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const [isModalRecordTimeHistory, setIsModalRecordTimeHistory] =
    useState<boolean>(false);

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");


  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "date",
      width: 50,
      disablePadding: false,
      align: "start",
      label: "วัน/เดือน/ปี",
    },
    {
      id: "check_in",
      disablePadding: false,
      width: 75,
      align: "center",
      label: "เวลาเข้างาน",
    },
    {
      id: "check_out",
      disablePadding: false,
      align: "center",
      width: 25,
      label: "เวลาออกงาน",
    },
    {
      id: "hour",
      disablePadding: false,
      align: "center",
      width: 40,
      label: "จำนวนชั่วโมง",
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_work_schedule,
      date,
      check_in,
      check_out,
      number_of_hours,
      latitude_in,
      longitude_in,
      latitude_out,
      longitude_out,
      detail_in,
      detail_out,
      file_path_in,
      file_path_out,
    } = objData;

    const objRenderData = {
      key: id_work_schedule,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${date}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: check_in || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: check_out || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: number_of_hours,
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <RemoveRedEyeOutlined
                onClick={() => {
                  setIsModalRecordTimeHistory(true);
                  setDataTimeRecordDetail({
                    id_work_schedule: id_work_schedule,
                    date: date,
                    check_in: check_in,
                    check_out: check_out,
                    number_of_hours: number_of_hours,
                    latitude_in: latitude_in ?? 0,
                    longitude_in: longitude_in ?? 0,
                    latitude_out: latitude_out ?? 0,
                    longitude_out: longitude_out ?? 0,
                    detail_in: detail_in,
                    detail_out: detail_out,
                    file_path_in: file_path_in ?? null,
                    file_path_out: file_path_out ?? null,
                  });
                }}
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const getTimeRecord = useCallback(async (emp_id: number) => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };
    if (startDate) query.sdate = moment(startDate).format("YYYY-MM-DD");
    if (endDate) query.edate = moment(endDate).format("YYYY-MM-DD");
    await workScheduleApi.getTimeRecordByEmployeeId(emp_id, query).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataTimeRecord(data.data.items.record_time.items);
        setTotalItems(res.data?.data?.items?.meta?.totalItems || 0);
        setInputValue({
          fullname:
            (data?.data?.items?.employee_info?.first_name || "") + " " + (data?.data?.items?.employee_info?.last_name ?? ""),
          employee_no: data?.data?.items?.employee_info?.employee_no ?? "",
          position: data?.data?.items?.employee_info?.position_name ?? "",
          department: data?.data?.items?.employee_info?.department_name_th ?? "",
          profile: data?.data?.items?.employee_info?.file_path,
          percent: data?.data?.items?.percent_work_in_out || 0,
        });
      } else {
        setDataTimeRecord([]);
      }
    }).catch((err) => {
      console.log(err);
      setDataTimeRecord([]);
    })
  }, [employeeId, page, pageLimit, sortBy, sortType, startDate, endDate])

  useEffect(() => {
    if (employeeId) {
      getTimeRecord(employeeId);
    }
  }, [getTimeRecord]);

  const handleDownloadFile = async (
    export_type: string,
    employeeId: number
  ) => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      type: export_type,
    };
    dispatch(setLoading());
    await ReportApi.GetCheckInCheckOutByEmployeeId(query, employeeId)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `employee-time-record-${new Date().getTime()}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
          // window.open(URL.createObjectURL(blob), "blank")
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  return (
    <div>
      <ModalRecordTime
        setIsOpenModal={(isOpen: boolean) =>
          setIsModalRecordTimeHistory(isOpen)
        }
        isOpenModal={isModalRecordTimeHistory}
        actionType="history"
        onFetch={() => { }}
        data={dataTimeRecordDetail}
      />
      <NavigateListCustom
        navigateData={[
          {
            name: "จัดการระบบบันทึกเวลาปฏิบัติงาน",
            key: "1",
            pathName: routeName.cms.ManageTimeRecordSystem,
          },
          {
            name: "ข้อมูลการเข้าออกงานรายบุคคล",
            key: "2",
            pathName: pathname
          },
        ]}
      />
      <section className="my-4">
        <Typography variant="h3">ข้อมูลการเข้าออกงานรายบุคคล</Typography>
      </section>

      <section className="my-4">
        <Grid
          container
          spacing={2}
          alignItems="center" // Centers items vertically within the row
          justifyContent="center" // Centers all content horizontally
          direction="row" // Ensures the layout is in one line
        >
          <Grid item xs={2} lg={2} md={6} sm={12}>
            <UploadAvatar
              filePath={inputValueSearch.profile ?? ""}
              onDrop={() => { }}
              file={undefined}
              hiddenDeleteButton
              noClick={true}
            />
          </Grid>

          <Grid item xs={12} lg={2} md={6} sm={12}>
            <InputTextField
              size="small"
              heading="ชื่อ-นามสกุล"
              disabled
              value={inputValueSearch.fullname}
            />
          </Grid>

          <Grid item xs={12} lg={2} md={6} sm={12}>
            <InputTextField
              size="small"
              heading="เลขประจำตัวเจ้าหน้าที่"
              disabled
              value={inputValueSearch.employee_no}
            />
          </Grid>

          <Grid item xs={12} lg={2} md={6} sm={12}>
            <InputTextField
              size="small"
              heading="ตำแหน่งงาน"
              disabled
              value={inputValueSearch.position}
            />
          </Grid>

          <Grid item xs={12} lg={2} md={6} sm={12}>
            <InputTextField
              size="small"
              heading="หน่วยงาน"
              disabled
              value={inputValueSearch.department}
            />
          </Grid>

          <Grid item xs={12} lg={2} md={6} sm={12}>
            <InputTextField
              size="small"
              heading="เปอร์เซ็นต์การเข้าออกงาน (%)"
              disabled
              value={inputValueSearch.percent}
            />
          </Grid>
        </Grid>
      </section>

      <section className="my-4">
        <Typography variant="h5">ประวัติการเข้า-ออกงาน</Typography>
      </section>
      <div
        className="w-full mt-[40px]"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: "16px", width: "100%", maxWidth: "fit-content" }}>
          {/* <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          /> */}
          <StateComponents
            typeProps={[
              {
                seq: 1,
                gridProps: {
                  xs: 12,
                },
                type: "DATE_RANGE2",
                fieldProps: {
                  handleChange: (st, end) => {
                    setStartDate(st || "");
                    setEndDate(end || "")
                  },
                  placeholder: "ช่วงวันที่",
                  value: {
                    end_date: endDate,
                    start_date: startDate,
                  },
                }
              }
            ]}
          />
        </div>

        <div style={{ display: "flex", gap: "16px" }}>
          <DropdownButton
            buttonName={t("BUTTON.DOWNLOAD_FILE")}
            menuItems={[
              {
                id: 1,
                name: "pdf",
                onClick: () => {
                  handleDownloadFile("pdf", employeeId);
                },
              },
              {
                id: 2,
                name: "excel",
                onClick: () => {
                  handleDownloadFile("xlsx", employeeId);
                },
              },
            ]}
          />
        </div>
      </div>
      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataTimeRecord &&
            dataTimeRecord.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>

      <section
        className="my-4"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <ButtonBack
          onClick={() => {
            navigate(routeName.cms.ManageTimeRecordSystem);
          }}
          buttonName={"ย้อนกลับ"}
        />
      </section>
    </div>
  );
};

export default ManageTimeRecordSystemDetail;
